import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fb0ef266")

_pushScopeId("data-v-fb0ef266")
const _hoisted_1 = { class: "quiz br-xl" }
const _hoisted_2 = { class: "t-center clip" }
const _hoisted_3 = {
  key: 0,
  class: "board br-lg p-16 df-col"
}
const _hoisted_4 = {
  class: "title t-center f-lg f-bold",
  style: {"line-height":"48px"}
}
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "d-f mt-16" }
const _hoisted_7 = { class: "progress" }
const _hoisted_8 = { class: "flex-1 question ml-12" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("No")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_12 = {
  key: 1,
  class: "board br-lg p-16 df-col"
}
const _hoisted_13 = {
  class: "title t-center f-lg f-bold",
  style: {"line-height":"48px"}
}
const _hoisted_14 = { class: "flex-1 df-middle df-center" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("You have completed this quiz.")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("It's not the time for the quiz, please come at the designated time. ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("OK")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_Line = _resolveComponent("Line")
  const _component_t = _resolveComponent("t")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Loading = _resolveComponent("Loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Pic, {
        src: "home/clip",
        width: "180"
      })
    ]),
    (_ctx.doneStatus===0)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.qaList[_ctx.questionIndex].title), 1),
          _createVNode(_component_Line),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.questionIndex + 1) + "/" + _toDisplayString(_ctx.qaList.length), 1),
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.question.question), 1)
            ]),
            _createVNode("div", {
              class: ["d-f mt-32", {answered: _ctx.answered}]
            }, [
              _createVNode("button", {
                class: ["btn flex-1 choice", {valid: _ctx.question.answer === _ctx.YES}],
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.makeChoice(_ctx.YES)))
              }, [
                _createVNode(_component_t, { path: "quiz_2" }, {
                  default: _withId(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_Icon, {
                  name: _ctx.question.answer === _ctx.YES ? 'check' : 'close',
                  sm: ""
                }, null, 8, ["name"]), [
                  [_vShow, _ctx.showAnsweredTip(_ctx.YES)]
                ])
              ], 2),
              _createVNode("button", {
                class: ["btn flex-1 choice ml-16", {valid: _ctx.question.answer === _ctx.NO}],
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.makeChoice(_ctx.NO)))
              }, [
                _createVNode(_component_t, { path: "quiz_3" }, {
                  default: _withId(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_Icon, {
                  name: _ctx.question.answer === _ctx.NO ? 'check' : 'close',
                  sm: ""
                }, null, 8, ["name"]), [
                  [_vShow, _ctx.showAnsweredTip(_ctx.NO)]
                ])
              ], 2)
            ], 2),
            _withDirectives(_createVNode("p", { class: "c-success mt-16 f-md" }, _toDisplayString(_ctx.question.description), 513), [
              [_vShow, _ctx.answered]
            ])
          ]),
          _createVNode("button", {
            class: ["primary btn f-lg f-bold", {disabled: !_ctx.answered}],
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
          }, [
            _createVNode(_component_t, {
              path: _ctx.isLastQuestion ? 'quiz_5' : 'quiz_4'
            }, {
              default: _withId(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["path"])
          ], 2)
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_12, [
          _createVNode("p", _hoisted_13, _toDisplayString(_ctx.qaList[_ctx.questionIndex].title), 1),
          _createVNode(_component_Line),
          _createVNode("div", _hoisted_14, [
            (_ctx.finishCheck)
              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                  (_ctx.doneStatus===1)
                    ? (_openBlock(), _createBlock(_component_t, {
                        key: 0,
                        path: "quiz_6",
                        as: "p"
                      }, {
                        default: _withId(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.doneStatus===2)
                    ? (_openBlock(), _createBlock(_component_t, {
                        key: 1,
                        path: "quiz_7",
                        as: "p"
                      }, {
                        default: _withId(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock(_component_Loading, { key: 1 }))
          ]),
          _createVNode("button", {
            class: "primary btn f-lg f-bold",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, [
            _createVNode(_component_t, { path: "withdrawal_34" }, {
              default: _withId(() => [
                _hoisted_18
              ]),
              _: 1
            })
          ])
        ])),
    _createVNode(_component_Icon, {
      name: "close",
      class: "close",
      onClick: _ctx.close
    }, null, 8, ["onClick"])
  ]))
})